import { useEffect } from 'react'

import TwoColumnPageContainer, {
  PageNav,
  NavItem,
} from 'components/two-column-responsive-page-container'
import { settingsPath as indexPath } from 'lib/urls'
import BackLink from 'shared/back-link'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import css from './RegistrySettingsPage.styles.scss'
import type { NavigationSettings } from '../constants'
import { Outlet, useLocation } from 'react-router-dom-v5-compat'

interface SettingsPageProps {
  navigation: Array<NavigationSettings>
  webView: boolean
}

const SettingsPage = ({ navigation, webView }: SettingsPageProps) => {
  const { pathname } = useLocation()
  const [currentUser] = useCurrentUser()
  const navItems = navigation.map(({ label, path, active, isVisible }) => {
    if (!isVisible(currentUser)) return null

    return (
      <NavItem active={active(pathname)} path={path} key={path}>
        {label}
      </NavItem>
    )
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return (
    <div className={`${css.SettingsPage} ${!currentUser ? css.isLoading : ''}`}>
      <TwoColumnPageContainer
        title="Settings"
        mobileBack={
          !webView && <BackLink to={indexPath}>Back to Settings</BackLink>
        }
        mobileHideMenu={pathname !== indexPath}
        mobileHideContent={pathname === indexPath}
      >
        <PageNav>{navItems}</PageNav>
        <Outlet />
      </TwoColumnPageContainer>
    </div>
  )
}

export default SettingsPage
